import { createContext } from 'react';

const SlidePanelContext = createContext(null);

export default SlidePanelContext;
